<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <!-- card main -->
        <v-card class="elevation-2 mt-5">
            <v-card-title class="blue-grey darken-4 white--text">
                Lista de ventas (punto de ventas)
                <v-spacer></v-spacer>
                <v-btn @click="scroll_left" fab small>
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn @click="scroll_right" fab small>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Número</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='number', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='number', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtNumber"
                                                    label="Número"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('number')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            Acciones
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Estado</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='state', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='state', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-select
                                                    v-model="txtState"
                                                    :items="itemsStatus"
                                                    item-text="label"
                                                    item-value="val"
                                                    label="Estados"
                                                    multiple
                                                    chips
                                                    outlined
                                                    hide-details
                                                    dense
                                                >
                                                    <template v-slot:selection="data">
                                                        <v-chip
                                                            :color="data.item.color"
                                                            small
                                                            class="white--text"
                                                        >
                                                            {{ data.item.label }}
                                                        </v-chip>
                                                    </template>
                                                </v-select>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('state')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left" style="min-width:150px">
                            <div class="d-flex align-center">
                                <span>Fecha</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='created_at', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='created_at', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtFecha"
                                                    label="Fecha"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="date"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('fecha')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Vendedor</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='full_seller', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='full_seller', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtVendedor"
                                                    label="Cliente"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('vendedor')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Cliente</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='full_name', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='full_name', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtSearch"
                                                    label="Cliente"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('txt')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Celular</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='phone_number', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='phone_number', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtPhone"
                                                    label="Celular"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('phone')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Tipo</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='type_order', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='type_order', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-select
                                                    v-model="txtType"
                                                    :items="itemsTypeO"
                                                    item-text="label"
                                                    item-value="val"
                                                    label="Tipo de orden"
                                                    outlined
                                                    hide-details
                                                    dense
                                                ></v-select>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('typeO')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left blue-grey lighten-4" style="min-width:200px" v-for="(art, j) in maxProds" :key="j">
                            Artículo {{ j+1 }}
                        </th>
                        <th class="text-right" style="min-width:100px">
                            <div class="d-flex align-center">
                                <span>Total {{ money }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='total', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='total', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtTotal"
                                                    label="Total"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="number"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('total')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in listOrders" :key="index">
                        <td>{{ item.number }}</td>
                        <td>
                            <div class="d-flex">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            :href="`/admin/cash-register/${item.id}`"
                                        >
                                            <v-icon color="grey">
                                                mdi-eye
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Ver</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            :href="`/admin/print-sale/${item.id}`"
                                            target="_blank"
                                        >
                                            <v-icon color="grey">
                                                mdi-printer
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Imprimir</span>
                                </v-tooltip>
                            </div>
                        </td>
                        <td>
                            <v-chip v-if="item.state=='Nuevo'" class="white--text" color="blue" small>
                                {{ item.state }}
                            </v-chip>
                            <v-chip v-if="item.state=='Procesando'" class="white--text" color="teal" small>
                                {{ item.state }}
                            </v-chip>
                            <v-chip v-if="item.state=='En espera'" color="" small>
                                {{ item.state }}
                            </v-chip>
                            <v-chip v-if="item.state=='Completado'" color="success" small>
                                {{ item.state }}
                            </v-chip>
                            <v-chip v-if="item.state=='Cancelado'" color="grey" small>
                                {{ item.state }}
                            </v-chip>
                            <v-chip v-if="item.state=='Reembolsado'" class="white--text" color="deep-orange" small>
                                {{ item.state }}
                            </v-chip>
                            <v-chip v-if="item.state=='Fallido'" color="error" small>
                                {{ item.state }}
                            </v-chip>
                            <v-chip v-if="item.state=='WhatsApp'" class="white--text" color="#36a884" small>
                                {{ item.state }}
                            </v-chip>
                            <div v-if="item.state=='Pendiente'" class="d-flex">
                                <v-btn
                                    small
                                    color="success"
                                    class="mr-2 text-capitalize"
                                    :loading="loading2"
                                    @click="aceptarRechazar('aceptar', item.id)"
                                >Aceptar</v-btn>
                                <v-btn
                                    small
                                    color="error"
                                    class="text-capitalize"
                                    :loading="loading2"
                                    @click="aceptarRechazar('rechazar', item.id)"
                                >Rechazar</v-btn>
                            </div>
                        </td>
                        <td>{{ item.date }}</td>
                        <td>{{ item.full_seller }}</td>
                        <td>{{ item.full_name }}</td>
                        <td>{{ item.phone_number }}</td>
                        <td>{{ item.type_order }}</td>
                        <template v-for="(article, i) in item.products">
                        <td class="blue-grey lighten-4" :key="i+1*123">
                            {{ article.name }} x{{ article.pivot.quantity }} {{ money }}{{ article.price }} - {{ article.pivot.extra }}
                            {{ article.myComplements }}
                        </td>
                        </template>
                        <template v-for="(temp, j) in (maxProds -item.products.length)">
                        <td class="blue-grey lighten-4" :key="j+1*321">-</td>
                        </template>
                        <td class="text-right">
                            {{ (item.total>0)?item.total:0 }}
                        </td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-card>
        <div class="text-right py-2" v-html="pageTable"></div>
        <v-pagination
            v-model="page"
            :length="totalPage"
            :total-visible="5"
            color="primary"
            @input="changePage"
            class="my-5"
        ></v-pagination>
        <!-- end card main -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </v-container>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            loading2: false,
            breadcrumbs: [
                {
                    text: 'Pedidos',
                    disabled: false,
                    href: '/admin/cash-register',
                },
                {
                    text: 'Todos',
                    disabled: true,
                    href: '',
                }
            ],
            tmpSlug: 'http://'+window.location.hostname+'/',
            // list data
            listOrders: [],
            maxProds: 0,
            pageTable: '',
            page: 1,
            totalPage: null,
            txtSearch: '',
            itemsStatus: [
                {label: 'Nuevo', val: 'Nuevo', color: 'blue'},
                {label: 'Pendiente', val: 'Pendiente', color: 'blue'},
                {label: 'Procesando', val: 'Procesando', color: 'teal'},
                {label: 'En espera', val: 'En espera', color: ''},
                {label: 'Completado', val: 'Completado', color: 'success'},
                {label: 'Cancelado', val: 'Cancelado', color: 'grey'},
                {label: 'Reembolsado', val: 'Reembolsado', color: 'deep-orange'},
                {label: 'Fallido', val: 'Fallido', color: 'error'},
            ],
            itemsTypeO: [
                {label: 'En mesa', val: 'En mesa'},
                {label: 'Para llevar', val: 'Para llevar'},
                {label: 'En sitio', val: 'En sitio'},
                {label: 'Para enviar', val: 'Para enviar'},
            ],
            txtState: [],
            txtNumber: '',
            txtPhone: '',
            txtType: '',
            txtVendedor: '',
            txtTotal: '',
            txtFecha: '',
            // export
            menuInit: false,
            menuEnd: false,
            dateInit: '',
            dateEnd: '',
            orderType: 'DESC',
            orderBy: 'created_at'
        }
    },
    props: ['money'],
    mounted() {
        this.getListOrders()
    },
    methods: {
        /**
         * List categories
         */
        processSearch () {
            this.page = 1
            this.getListOrders()
        },
        changePage (event) {
            this.page = event;
            this.getListOrders()
        },
        cleanSearch (type='') {
            if (type=='') {
                if ( (this.txtSearch !== '') || (this.txtState.length>0) || (this.dateInit!='') || (this.dateEnd!='') ) {
                    this.listOrders = []
                    this.page = 1
                    this.txtSearch = ''
                    this.txtState = []
                    this.dateInit = ''
                    this.dateEnd = ''
                    this.txtNumber = ''
                    this.getListOrders();
                }
            } else {
                switch (type) {
                    case 'state':
                        this.txtState = []
                        this.getListOrders();
                        break;
                    case 'txt':
                        this.txtSearch = ''
                        this.getListOrders();
                        break;
                    case 'phone':
                        this.txtPhone = ''
                        this.getListOrders();
                        break;
                    case 'number':
                        this.txtNumber = ''
                        this.getListOrders();
                        break;
                    case 'typeO':
                        this.txtType = ''
                        this.getListOrders();
                        break;
                    case 'vendedor':
                        this.txtVendedor = ''
                        this.getListOrders();
                        break;
                    case 'total':
                        this.txtTotal = ''
                        this.getListOrders();
                        break;
                    case 'fecha':
                        this.txtFecha = ''
                        this.getListOrders();
                        break;
                    default:
                        break;
                }
            }
        },
        async getListOrders () {
            this.listOrders = []
            this.overlay = true
            await axios.post(`/admin/list-sales?page=${this.page}
                            &orderby=${this.orderBy}
                            &ordertype=${this.orderType}
                            &search=${this.txtSearch}
                            &states=${JSON.stringify(this.txtState)}
                            &date_init=${this.dateInit}
                            &date_end=${this.dateEnd}
                            &number=${this.txtNumber}
                            &phone=${this.txtPhone}
                            &type=${this.txtType}
                            &vendedor=${this.txtVendedor}
                            &total=${this.txtTotal}
                            &fecha=${this.txtFecha}
                        `, {})
            .then(response => {
                // console.log(response)
                response.data[0].data.forEach(element => {
                    const d = new Date(element.created_at)
                    element.date = d.getDate() +'-'+ (d.getMonth()+1) +'-'+ d.getFullYear() +'  '+ d.getHours()+':'+d.getMinutes()
                    element.products.forEach(prod => {
                        let tmpComplements = JSON.parse(prod.pivot.complements)
                        var myComplements = '';
                        if (tmpComplements.multi.length > 0) {
                            tmpComplements.multi.forEach(val => {
                                let tmp = val.split(':');
                                myComplements += (tmp[0]+' x'+tmp[2]+' '+tmp[1]+this.money);
                                myComplements += ' - ';
                            });
                        }
                        if (tmpComplements.only.length > 0) {
                            tmpComplements.only.forEach(val => {
                                let tmp = val.split(':');
                                myComplements += (tmp[0]+' '+tmp[1]+this.money+' x1');
                                myComplements += ' - ';
                            });
                        }
                        prod.myComplements = myComplements
                    });
                    this.listOrders.push(element)
                });
                // this.listOrders = response.data[0].data
                this.totalPage = response.data[0].last_page
                this.pageTable = `Mostrando <strong>${response.data[0].from??0} - ${response.data[0].to??0}</strong> de un total de <strong>${response.data[0].total}</strong>`

                this.maxProds = response.data[1]

                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },
        /**
         * scroll
         */
        scroll_left() {
        let content = document.querySelector(".v-data-table__wrapper");
            content.scrollLeft -= 100;
        },
        scroll_right() {
            let content = document.querySelector(".v-data-table__wrapper");
            content.scrollLeft += 100;
        },

        /**
         * Aceptar/rechazar
         */
        async aceptarRechazar(type, id) {
            this.loading2 = true
            await axios.post('/admin/accept-reject', {type:type, id:id})
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$alert('', 'Cambio de estado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                    this.getListOrders()
                }
                this.loading2 = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading2 = false
            })
        }
    },
}
</script>
